import {createSlice, createAsyncThunk, createAction, current} from '@reduxjs/toolkit'
import {TAG as name} from '../../../store/slices/config'
import _ from 'lodash'
import {
  _fetchTagList,
  _fetchEnginList,
  _getGeoByIdGeo,
  _fetchInactiveEngin,
  _tagPosition,
  _removeEngine,
  _activateEngine,
  _activateObject,
  _fetchStatusListHistory,
  _getTagHistories,
  _getAlertList,
  _saveAlert,
  _getAlertHistories,
  _saveAlertHistorique,
  _generateTagReport,
  _getReportsList,
} from '../api/api'

// Import the working _fetchTags API from Tag API that TagList.js uses successfully
// Import the working _fetchTags API from Tag component
import { _fetchTags } from '../../Tag/api/api'
import {socket} from '../../../socket/socket'
import {_getGeoByIdSite, _saveEngineTypes} from '../../../api'
import {setToastParams} from '../../../store/slices/ui.slice'

// Add fetchTags async thunk following the same pattern as tag.slice.js
export const fetchTags = createAsyncThunk(
  `${name}/fetchTags`,
  async (_args, {getState, dispatch}) => {
    try {
      console.log('🏷️ FETCHING TAGS WITH PARAMS:', _args)
      
      // Use the working _fetchTags API (same as TagList.js uses)
      let response = await _fetchTags(_args)
      
      console.log('🏷️ RAW API RESPONSE:', response)

      
      if (!response.error) {
        console.log('🏷️ NO ERROR IN RESPONSE')
        
        if (response.data) {
          console.log('🏷️ RECEIVED TAG DATA:', response.data)
          console.log('🏷️ FIRST TAG EXAMPLE:', response.data?.[0])

          
          // Return data to be handled by fetchTags.fulfilled reducer
          console.log('🏷️ RETURNING DATA TO REDUCER')
          return response.data
        } else {
          console.log('🏷️ NO DATA IN RESPONSE - response.data is null/undefined')
        }
      } else {
        console.log('🏷️ API RETURNED ERROR:', response.error)
      }
      
      console.log('🏷️ RETURNING EMPTY ARRAY')
      dispatch(setToastParams({
        severity: 'error',
        summary: 'Erreur',
        detail: 'Erreur lors du chargement de la liste des capteurs',
        life: 3000
      }))
      return []
    } catch (e) {
      console.log('🏷️ FETCH TAGS EXCEPTION:', e)
      console.log('🏷️ EXCEPTION MESSAGE:', e.message)
      console.log('🏷️ EXCEPTION STACK:', e.stack)
      dispatch(setToastParams({
        severity: 'error',
        summary: 'Erreur',
        detail: 'Erreur de connexion lors du chargement des capteurs',
        life: 3000
      }))
      return []
    }
  }
)

export const fetchTagList = createAsyncThunk(
  `${name}/fetchTagList`,
  async (_args, {getState, dispatch}) => {
    try {
      // Support both old format (page, pageSize) and new format with srcIds/srcObject
      let page = 1, pageSize = 50, srcIds = null, srcObject = 'engin'
      
      if (typeof _args === 'object' && _args !== null) {
        page = _args.page || 1
        pageSize = _args.pageSize || 50
        srcIds = _args.srcIds || null
        srcObject = _args.srcObject || 'engin'
      } else if (typeof _args === 'number') {
        page = _args
      }
      
      console.log('📡 fetchTagList params:', { page, pageSize, srcIds, srcObject })
      
      let response = await _fetchTagList(page, pageSize, srcIds, srcObject)
      if (!response.error) {
        dispatch(setTagList(response.data))
        return response.data
      } else {
        dispatch(
          setToastParams({
            show: true,
            severity: 'error',
            summary: 'ERREUR',
            detail: 'Erreur lors du chargement de la liste des capteurs',
            position: 'top-right',
          })
        )
      }
      return []
    } catch (e) {
      console.log('fetchTagList', e)
      dispatch(
        setToastParams({
          show: true,
          severity: 'error',
          summary: 'ERREUR',
          detail: 'Erreur de connexion lors du chargement des capteurs',
          position: 'top-right',
        })
      )
      return []
    }
  }
)

// New async thunk for engin/list
export const fetchEnginList = createAsyncThunk(
  `${name}/fetchEnginList`,
  async (_args, {getState, dispatch}) => {
    try {
      // Support both old format (page, pageSize) and new format with srcIds/srcObject
      let page = 1, pageSize = 50, srcIds = null, srcObject = 'engin'
      
      if (typeof _args === 'object' && _args !== null) {
        page = _args.page || 1
        pageSize = _args.pageSize || 50
        srcIds = _args.srcIds || null
        srcObject = _args.srcObject || 'engin'
      } else if (typeof _args === 'number') {
        page = _args
      }
      
      console.log('📡 fetchEnginList params:', { page, pageSize, srcIds, srcObject })
      
      let response = await _fetchEnginList(page, pageSize, srcIds, srcObject)
      if (response.data && response.data.success && response.data.result) {
        const enginData = Array.isArray(response.data.result) ? response.data.result : []
        console.log('✅ Engins chargés:', enginData.length)
        dispatch(setTagList(enginData)) // Use same action for consistency
        return enginData
      } else {
        console.log('❌ Erreur dans la réponse engin/list:', response)
        dispatch(
          setToastParams({
            show: true,
            severity: 'error',
            summary: 'ERREUR',
            detail: 'Erreur lors du chargement de la liste des engins',
            position: 'top-right',
          })
        )
      }
      return []
    } catch (e) {
      console.log('🚨 fetchEnginList error:', e)
      dispatch(
        setToastParams({
          show: true,
          severity: 'error',
          summary: 'ERREUR',
          detail: 'Erreur de connexion lors du chargement des engins',
          position: 'top-right',
        })
      )
      return []
    }
  }
)

export const fetchTagHistories = createAsyncThunk(
  `${name}/fetchTagHistories`,
  async (_args, {getState, dispatch}) => {
    try {
      console.log('🔍 fetchTagHistories args:', _args)
      
      // Support both old format (array) and new format (object)
      let requestData
      if (!_args) {
        console.log('❌ No args provided to fetchTagHistories')
        return {}
      }
      
      if (Array.isArray(_args)) {
        // Old format: array of macAddresses
        if (_args.length === 0) {
          console.log('❌ Empty array provided to fetchTagHistories')
          return {}
        }
        console.log('🔍 Using old format (array of macAddresses):', _args)
        requestData = _args
      } else if (typeof _args === 'object') {
        // New format: {tags, from, to, mode}
        console.log('🔍 Using new format (object):', _args)
        if (!_args.tags || _args.tags.length === 0) {
          console.log('❌ No tags provided in object format')
          return {}
        }
        requestData = {
          tags: _args.tags, // tagname des capteurs
          from: _args.from || null,
          to: _args.to || null,
          srcObject: _args.srcObject || 'engin',
          srcIds: _args.srcIds || null // uid/id des capteurs
        }
      } else {
        console.log('❌ Invalid args format for fetchTagHistories:', typeof _args)
        return {}
      }
      
      console.log('📡 Calling _getTagHistories with:', requestData)
      let response = await _getTagHistories(requestData)
      console.log('📊 Raw API response:', response)
      console.log('📊 Response.success:', response?.success)
      console.log('📊 Response.response:', response?.response)
      console.log('📊 Response.errors:', response?.errors)
      console.log('📊 Response.data:', response?.data)
      
      // Check response.success instead of response.error
      if (response.success && response.response) {
        console.log('✅ API call successful, using response.response as data')
        dispatch(setTagHistories(response.response))
        return response.response
      } else {
        console.log('❌ API returned error or no success:', {
          success: response.success,
          errors: response.errors,
          response: response.response
        })
        dispatch(
          setToastParams({
            show: true,
            severity: 'error',
            summary: 'ERREUR',
            detail: `Erreur lors du chargement de l'historique: ${response.errors?.[0] || 'Erreur inconnue'}`,
            position: 'top-right',
          })
        )
      }
      return {}
    } catch (e) {
      console.log('🚨 fetchTagHistories exception:', e)
      dispatch(
        setToastParams({
          show: true,
          severity: 'error',
          summary: 'ERREUR',
          detail: 'Erreur de connexion lors du chargement de l\'historique',
          position: 'top-right',
        })
      )
      return {}
    }
  }
)

// Alert async thunks
export const fetchAlertList = createAsyncThunk(
  `${name}/fetchAlertList`,
  async (_, {dispatch}) => {
    try {
      console.log('🚨 fetchAlertList called - fetching all alerts')
      
      const response = await _getAlertList()
      console.log('🚨 fetchAlertList response:', response)
      console.log('🚨 response.success:', response.success)
      console.log('🚨 response.result:', response.result)
      console.log('🚨 response keys:', Object.keys(response))
      
      if (response.success && response.result) {
        console.log('✅ Alert list fetched successfully:', response.result.length, 'alerts')
        console.log('🚀 About to dispatch setAlertList with:', response.result)
        dispatch(setAlertList(response.result))
        console.log('🚀 Dispatch setAlertList completed')
        return response.result
      } else if (response.success && response.response) {
        console.log('✅ Alert list found in response.response:', response.response.length, 'alerts')
        console.log('🚀 About to dispatch setAlertList with:', response.response)
        dispatch(setAlertList(response.response))
        console.log('🚀 Dispatch setAlertList completed')
        return response.response
      } else {
        console.log('❌ API returned error or no data:', response)
        dispatch(
          setToastParams({
            show: true,
            severity: 'error',
            summary: 'ERREUR',
            detail: `Erreur lors du chargement des alertes: ${response.errors?.[0] || 'Erreur inconnue'}`,
            position: 'top-right',
          })
        )
      }
      return []
    } catch (e) {
      console.log('🚨 fetchAlertList exception:', e)
      dispatch(
        setToastParams({
          show: true,
          severity: 'error',
          summary: 'ERREUR',
          detail: 'Erreur de connexion lors du chargement des alertes',
          position: 'top-right',
        })
      )
      return []
    }
  }
)

export const saveAlert = createAsyncThunk(
  `${name}/saveAlert`,
  async (data, {dispatch}) => {
    try {
      console.log('🚨 saveAlert called with:', data)
      
      if (!data) {
        console.log('❌ Data is required for saveAlert')
        dispatch(
          setToastParams({
            show: true,
            severity: 'error',
            summary: 'ERREUR',
            detail: 'Données requises pour sauvegarder l\'alerte',
            position: 'top-right',
          })
        )
        return null
      }
      
      const response = await _saveAlert(data)
      console.log('🚨 saveAlert response:', response)
      
      if (response.success) {
        console.log('✅ Alert saved successfully')
        dispatch(
          setToastParams({
            show: true,
            severity: 'success',
            summary: 'SUCCÈS',
            detail: 'Alerte sauvegardée avec succès',
            position: 'top-right',
          })
        )
        return response.response
      } else {
        console.log('❌ API returned error:', response.errors)
        dispatch(
          setToastParams({
            show: true,
            severity: 'error',
            summary: 'ERREUR',
            detail: `Erreur lors de la sauvegarde: ${response.errors?.[0] || 'Erreur inconnue'}`,
            position: 'top-right',
          })
        )
      }
      return null
    } catch (e) {
      console.log('🚨 saveAlert exception:', e)
      dispatch(
        setToastParams({
          show: true,
          severity: 'error',
          summary: 'ERREUR',
          detail: 'Erreur de connexion lors de la sauvegarde de l\'alerte',
          position: 'top-right',
        })
      )
      return null
    }
  }
)

export const fetchAlertHistories = createAsyncThunk(
  `${name}/fetchAlertHistories`,
  async (data, {dispatch}) => {
    try {
      console.log('🚨 fetchAlertHistories called with:', data)
      
      if (!data || !data.tagID) {
        console.log('❌ tagID is required for fetchAlertHistories')
        dispatch(
          setToastParams({
            show: true,
            severity: 'error',
            summary: 'ERREUR',
            detail: 'ID du capteur requis pour récupérer l\'historique des alertes',
            position: 'top-right',
          })
        )
        return []
      }
      
      const response = await _getAlertHistories(data)
      console.log('🚨 fetchAlertHistories response:', response)
      
      if (response.success && response.response) {
        console.log('✅ Alert histories fetched successfully')
        dispatch(setAlertHistories(response.response))
        return response.response
      } else {
        console.log('❌ API returned error:', response.errors)
        dispatch(
          setToastParams({
            show: true,
            severity: 'error',
            summary: 'ERREUR',
            detail: `Erreur lors du chargement de l'historique: ${response.errors?.[0] || 'Erreur inconnue'}`,
            position: 'top-right',
          })
        )
      }
      return []
    } catch (e) {
      console.log('🚨 fetchAlertHistories exception:', e)
      dispatch(
        setToastParams({
          show: true,
          severity: 'error',
          summary: 'ERREUR',
          detail: 'Erreur de connexion lors du chargement de l\'historique des alertes',
          position: 'top-right',
        })
      )
      return []
    }
  }
)

export const saveAlertHistorique = createAsyncThunk(
  `${name}/saveAlertHistorique`,
  async (data, {dispatch}) => {
    try {
      console.log('🚨 saveAlertHistorique called with:', data)
      
      if (!data) {
        console.log('❌ Data is required for saveAlertHistorique')
        dispatch(
          setToastParams({
            show: true,
            severity: 'error',
            summary: 'ERREUR',
            detail: 'Données requises pour sauvegarder l\'historique',
            position: 'top-right',
          })
        )
        return null
      }
      
      const response = await _saveAlertHistorique(data)
      console.log('🚨 saveAlertHistorique response:', response)
      
      if (response.success) {
        console.log('✅ Alert historique saved successfully')
        dispatch(
          setToastParams({
            show: true,
            severity: 'success',
            summary: 'SUCCÈS',
            detail: 'Historique d\'alerte sauvegardé avec succès',
            position: 'top-right',
          })
        )
        return response.response
      } else {
        console.log('❌ API returned error:', response.errors)
        dispatch(
          setToastParams({
            show: true,
            severity: 'error',
            summary: 'ERREUR',
            detail: `Erreur lors de la sauvegarde: ${response.errors?.[0] || 'Erreur inconnue'}`,
            position: 'top-right',
          })
        )
      }
      return null
    } catch (e) {
      console.log('🚨 saveAlertHistorique exception:', e)
      dispatch(
        setToastParams({
          show: true,
          severity: 'error',
          summary: 'ERREUR',
          detail: 'Erreur de connexion lors de la sauvegarde de l\'historique',
          position: 'top-right',
        })
      )
      return null
    }
  }
)

// Generate Tag Report async thunk
export const generateTagReport = createAsyncThunk(
  `${name}/generateTagReport`,
  async (reportData, {dispatch}) => {
    try {
      console.log('📊 generateTagReport called with:', reportData)
      
      const response = await _generateTagReport(reportData)
      
      if (response.success) {
        console.log('✅ Report generated successfully:', response)
        
        dispatch(
          setToastParams({
            severity: 'success',
            summary: 'SUCCÈS',
            detail: 'Rapport généré avec succès',
            position: 'top-right',
          })
        )
        
        return response.result
      } else {
        console.error('❌ Report generation failed:', response.error)
        
        dispatch(
          setToastParams({
            severity: 'error',
            summary: 'ERREUR',
            detail: response.error || 'Erreur lors de la génération du rapport',
            position: 'top-right',
          })
        )
        
        return null
      }
    } catch (error) {
      console.error('❌ Generate tag report error:', error)
      
      dispatch(
        setToastParams({
          severity: 'error',
          summary: 'ERREUR',
          detail: 'Erreur de connexion lors de la génération du rapport',
          position: 'top-right',
        })
      )
      
      return null
    }
  }
)

// Fetch Reports List
export const fetchReportsList = createAsyncThunk(
  `${name}/fetchReportsList`,
  async (_, {dispatch}) => {
    try {
      console.log('📋 fetchReportsList called')
      
      const response = await _getReportsList()
      console.log('📋 Reports list response:', response)
      
      const apiResponse = response.data || response
      
      if (apiResponse.success && apiResponse.result) {
        const reports = Array.isArray(apiResponse.result) 
          ? apiResponse.result 
          : apiResponse.result.reports || []
        
        console.log('📋 Reports fetched successfully:', reports)
        return reports
      } else {
        throw new Error('Aucun rapport trouvé dans la réponse')
      }
    } catch (error) {
      console.error('📋 Error fetching reports list:', error)
      
      dispatch(setToastParams({
        severity: 'error',
        summary: 'Erreur',
        detail: 'Erreur lors du chargement de la liste des rapports',
        life: 3000
      }))
      
      throw error
    }
  }
)

function groupePositionHistories(list) {
  try {
    let currentIndex = 0
    let currentLat = null
    let currentLng = null
    let currentLocation = null
    list.forEach((o, idx) => {
      if (
        (o.lat != currentLat || o.lng != currentLng) &&
        (o.LocationID == 0 || (o.LocationID != 0 && o.LocationID !== currentLocation))
      ) {
        currentIndex++
        o.locIndex = currentIndex
        currentLat = o.lat
        currentLng = o.lng
        currentLocation = o.LocationID
      } else {
        o.locIndex = currentIndex
      }
    })

    console.log('groupePositionHistories O:', list)
    return _.uniqBy(list, 'locIndex')
  } catch (e) {
    console.log('groupePositionHistories Error:', e.message)
    return list
  }
}

//Actions
export const setEngines = createAction(`${name}/fetchEngines`)
export const setEnginListHistory = createAction(`${name}/fetchEnginListHistory`)
export const setEnginesWorksite = createAction(`${name}/fetchEnginesWorksite`)
export const setShow = createAction(`${name}/setShow`)
export const setTypeList = createAction(`${name}/setTypeList`)
export const setSelectedEngine = createAction(`${name}/setSelectedEngine`)
export const setSelectedTag = createAction(`${name}/setSelectedTag`)
export const setEditEngine = createAction(`${name}/setEditEngine`)
export const setEditTagEngin = createAction(`${name}/setEditTagEngin`)
export const setTypeEdit = createAction(`${name}/setTypeEdit`)
export const setTypeFields = createAction(`${name}/setTypeFields`)
export const seTagEdit = createAction(`${name}/seTagEdit`)
export const setExistItem = createAction(`${name}/setExistItem`)
export const setTagList = createAction(`${name}/setTagList`)
export const setTagHistories = createAction(`${name}/setTagHistories`)
export const setTags = createAction(`${name}/setTags`)

const engineSlice = createSlice({
  name,
  initialState: {
    engines: [],
    geoByIdSite: [],
    statusList: [],
    objectsNoActive: [],
    statusListHistory: [],
    paramCardHis: {
      showList: false,
      title: '',
    },
    enginesHistory: [],
    enginesWorksite: [],
    inactiveEngin: [],
    selectedHistory: null,
    srcMovement: null,
    socketEnterOrExit: null,
    socketStatusChange: null,
    showHistory: false,
    typesList: [],
    typeFields: [],
    selectedTag: null,
    editTag: false,
    show: true,
    selectedEngine: null,
    editEngine: false,
    editTagEngin: false,
    editType: false,
    selectedEnginMap: null,
    existItem: false,
    lastUpdates: [],
    statusVisible: false,
    tagList: [],
    tagHistories: {},
    tags: [],
    tagsPagination: {
      page: 0,
      limit: 50,
      total: 0
    },
    alertList: [],
    alertHistories: [],
    reportGeneration: {
      loading: false,
      result: null,
      error: null
    },
    reportsList: {
      loading: false,
      data: [],
      error: null
    },
  },
  reducers: {
    setSocketEnterOrExit(state, {payload}) {
      state.socketEnterOrExit = payload
      const msg = payload.msg
      const id = payload?.data[0].enginId
      const findEngin = state.engines.find((item) => item.id === id)
      let newObj = {
        ...findEngin,
        etatengin: msg !== 'exit' ? 'Entrée' : 'Exit',
        etatenginname: msg !== 'exit' ? 'reception' : 'exit',
      }
      state.engines = state.engines.map((item) => {
        if (item.id === id) {
          return newObj
        }
        return item
      })
    },
    setStatusVisible(state, {payload}) {
      state.statusVisible = payload
    },
    setStatusListHistory(state, {payload}) {
      state.statusListHistory = payload
    },
    setStatusList(state, {payload}) {
      state.statusList = payload
    },
    setGeoByIdSite(state, {payload}) {
      state.geoByIdSite = payload
    },
    setUpdatedEngin(state, {payload}) {
      if (Array.isArray(state.engines) && state.engines.length > 0) {
        const newEngines = state.engines.map((item) => {
          const updatedItem = payload.find(
            (element) => element.id == item.id || element.uid == item.uid
          )
          return updatedItem ? {...item, ...updatedItem} : item
        })
        state.engines = newEngines
      }
    },
    setObjectsNoActive(state, {payload}) {
      state.objectsNoActive = payload
    },
    setInactiveEngin(state, {payload}) {
      state.inactiveEngin = payload
    },
    setParamCadHis(state, {payload}) {
      state.paramCardHis = {...state.paramCardHis, ...payload}
    },
    setSrcMouvement(state, {payload}) {
      state.srcMovement = payload
    },
    setShowHistory(state, {payload}) {
      state.showHistory = payload
    },
    setSelectedHistory(state, {payload}) {
      state.selectedHistory = payload
    },
    setSelectedEnginMap(state, {payload}) {
      state.selectedEnginMap = payload
    },
    setSocketStatusChange(state, {payload}) {
      state.socketStatusChange = payload
      state.engines = state.engines.map((item) => {
        if (item.uid == payload?.newObj.uid) {
          return {...payload?.newObj, iconName: payload.icon, statusbgColor: payload.statusbgColor}
        }
        return item
      })
      return
      const msg = payload?.data[0].typeMsg
      const id = payload?.data[0].enginId
      const findEngin = state.engines.find((item) => item.id === id)
      let newObj = {
        ...findEngin,
        statuslabel: payload?.statuslabel,
        statusname: payload?.statusname,
        statusbgColor: payload?.statusbgColor,
      }
    },
    updateEnginLastSeen(state, {payload}) {
      let data = _.cloneDeep(payload)
      if (!Array.isArray(data) || data?.length == 0) return
      let list = _.cloneDeep(state.lastUpdates)
      let engines = _.cloneDeep(state.engines)

      for (let engin of payload) {
        let eng = list.find(({id}) => id == engin.engin)
        let eng2 = engines.find(({id}) => id == engin.engin)
        if (eng) eng.lastSeenAt = engin.lastSeen
        if (eng2) eng2.lastSeenAt = engin.lastSeen
      }
      state.lastUpdates = list
      state.engines = engines
    },
    setLastEnginUpdates(state, {payload}) {
      let oldState = _.cloneDeep(state.lastUpdates)
      let newState = _.cloneDeep(payload)
      let oldEngins = _.cloneDeep(state.engines)
      if (!Array.isArray(oldState)) oldState = []
      if (!Array.isArray(newState)) newState = []
      if (!Array.isArray(oldEngins)) oldEngins = []

      for (let engin of newState) {
        let eng = oldEngins.find(({id}) => id == engin.id)
        console.log('oldEngin:', eng)
        if (eng) {
          for (const [k, v] of Object.entries(engin)) {
            eng[k] = v
          }
          eng.locationDate = engin.lastUpdate
          // eng.lastSeenAt = engin.lastSeenAt
          // eng.lastUpdate = engin.lastUpdate
          // eng.LocationID = engin.LocationID
          // eng.etatenginname = engin.etatenginname
          // eng.etatengin = engin.etatengin
          //
        }
      }
      let list2 = oldEngins.map((t) => {
        let eng = newState.find(({id}) => id == t.id)
        if (eng) {
          for (const [k, v] of Object.entries(eng)) {
            t[k] = v
          }
          // t.locationDate = eng.lastUpdate
          // t.lastSeenAt = eng.lastSeenAt
          // t.lastUpdate = eng.lastUpdate
          // t.LocationID = eng.LocationID
          // t.etatenginname = eng.etatenginname
          // t.etatengin = eng.etatengin
          t.locationDate = eng.lastUpdate
        }
        return t
      })
      console.log('data new new_updated_engins slice:', newState, oldEngins, list2)

      state.lastUpdates = newState
      state.engines = oldEngins
    },
  },
  extraReducers: {
    [setEngines]: (state, {payload}) => {
      state.engines = payload
    },
    [setEnginListHistory]: (state, {payload}) => {
      state.enginesHistory = payload
    },
    [setEnginesWorksite]: (state, {payload}) => {
      state.enginesWorksite = payload
    },
    [setSelectedEngine]: (state, {payload}) => {
      state.selectedEngine = payload
    },
    [setEditEngine]: (state, {payload}) => {
      state.editEngine = payload
    },
    [setTypeList]: (state, {payload}) => {
      state.typesList = payload
    },
    [setShow]: (state, {payload}) => {
      state.show = payload
    },
    [setEditTagEngin]: (state, {payload}) => {
      state.editTagEngin = payload
    },
    [setTypeEdit]: (state, {payload}) => {
      state.editType = payload
    },
    [setTypeFields]: (state, {payload}) => {
      state.typeFields = payload
    },
    [seTagEdit]: (state, {payload}) => {
      state.editTag = payload
    },
    [setSelectedTag]: (state, {payload}) => {
      state.selectedTag = payload
    },
    [setExistItem]: (state, {payload}) => {
      state.existItem = payload
    },
    [setTagList]: (state, {payload}) => {
      state.tagList = payload
    },
    [setTagHistories]: (state, {payload}) => {
      state.tagHistories = payload
    },
    [setTags]: (state, {payload}) => {
      state.tags = payload
    },
    // Handle fetchTags fulfilled action for pagination
    [fetchTags.fulfilled]: (state, {payload}) => {
      console.log('🔄 REDUCER RECEIVED PAYLOAD:', payload)
      console.log('🔄 PAYLOAD TYPE:', typeof payload)
      console.log('🔄 PAYLOAD IS ARRAY:', Array.isArray(payload))
      
      if (payload) {
        // Handle direct array payload (like tag.slice.js)
        if (Array.isArray(payload)) {
          console.log('🔄 STORING ARRAY PAYLOAD IN TAGS STATE')
          state.tags = payload
          state.tagsPagination = {
            page: 0,
            limit: 50,
            total: payload.length
          }
        } else if (payload.data) {
          // Handle object payload with data property
          console.log('🔄 STORING PAYLOAD.DATA IN TAGS STATE')
          state.tags = payload.data
          state.tagsPagination = payload.pagination || {
            page: 0,
            limit: 50,
            total: payload.data.length
          }
        }
      }
    },
    setAlertList: (state, {payload}) => {
      console.log('🔄 setAlertList reducer called with payload:', payload)
      state.alertList = payload
      console.log(' current state.alertList after:', state.alertList)
    },
    setAlertHistories(state, {payload}) {
      state.alertHistories = payload
    },
    // Generate Tag Report reducers
    [generateTagReport.pending]: (state) => {
      state.reportGeneration.loading = true
      state.reportGeneration.error = null
    },
    [generateTagReport.fulfilled]: (state, {payload}) => {
      state.reportGeneration.loading = false
      state.reportGeneration.result = payload
      state.reportGeneration.error = null
    },
    [generateTagReport.rejected]: (state, {payload}) => {
      state.reportGeneration.loading = false
      state.reportGeneration.result = null
      state.reportGeneration.error = payload
    },
    // Fetch Reports List reducers
    [fetchReportsList.pending]: (state) => {
      state.reportsList.loading = true
      state.reportsList.error = null
    },
    [fetchReportsList.fulfilled]: (state, {payload}) => {
      console.log('📋 Redux reducer - fetchReportsList.fulfilled called with payload:', payload)
      console.log('📋 Redux reducer - payload type:', typeof payload, 'isArray:', Array.isArray(payload))
      console.log('📋 Redux reducer - state before update:', current(state.reportsList))
      
      state.reportsList.loading = false
      state.reportsList.data = payload || []
      state.reportsList.error = null
      
      console.log('📋 Redux reducer - state.reportsList after update:', current(state.reportsList))
      console.log('📋 Redux reducer - data length:', state.reportsList.data?.length)
    },
    [fetchReportsList.rejected]: (state, {payload}) => {
      state.reportsList.loading = false
      state.reportsList.data = []
      state.reportsList.error = payload
    },
  },
})

//selectors
export const getEngines = (state) => state[name].engines
export const getEnginListHistory = (state) => state[name].enginesHistory
export const getEnginesWorksite = (state) => state[name].enginesWorksite
export const getSelectedEngine = (state) => state[name].selectedEngine
export const getEditEngine = (state) => state[name].editEngine
export const getTypeList = (state) => state[name].typesList
export const getEditTagEngin = (state) => state[name].editTagEngin
export const getShow = (state) => state[name].show
export const getEditType = (state) => state[name].editType
export const getTypeFields = (state) => state[name].typeFields
export const getTagEdit = (state) => state[name].editTag
export const getSelectedTag = (state) => state[name].selectedTag
export const getExistItem = (state) => state[name].existItem
export const getSelectedEnginMap = (state) => state[name].selectedEnginMap
export const getInactiveEngin = (state) => state[name].inactiveEngin
export const getShowHistory = (state) => state[name].showHistory
export const getSrcMouvement = (state) => state[name].srcMovement
export const getSelectedHistory = (state) => state[name].selectedHistory
export const getParamCardHis = (state) => state[name].paramCardHis
export const getGeoByIdPos = (state) => state[name].geoByIdSite
export const getLastEnginsUpdates = (state) => state[name].lastUpdates
export const getStatusList = (state) => state[name].statusList
export const getObjectsNoActive = (state) => state[name].objectsNoActive
export const getStatusVisible = (state) => state[name].statusVisible
export const getStatusListHistory = (state) => state[name].statusListHistory
export const getTagList = (state) => state[name].tagList
export const getTagHistories = (state) => state[name].tagHistories
export const getTags = (state) => state[name].tags
export const getTagsPagination = (state) => state[name].tagsPagination
export const getAlertList = (state) => {
  console.log('🔍 getAlertList selector called')
  console.log('🔍 slice name in config:', name)
  console.log('🔍 actual store key: tag')
  console.log('🔍 state.tag:', state.tag)
  console.log('🔍 state.tag.alertList:', state.tag?.alertList)
  return state.tag?.alertList || []
}
export const getAlertHistories = (state) => state[name].alertHistories
export const getReportGeneration = (state) => state[name].reportGeneration
export const getReportGenerationLoading = (state) => state[name].reportGeneration.loading
export const getReportGenerationResult = (state) => state[name].reportGeneration.result
export const getReportGenerationError = (state) => state[name].reportGeneration.error
export const getReportsList = (state) => {
  const result = state[name].reportsList || { loading: false, data: [], error: null }
  console.log('📋 getReportsList selector - state[name]:', state[name])
  console.log('📋 getReportsList selector - reportsList:', result)
  return result
}
export const getReportsListData = (state) => {
  // Force l'initialisation de reportsList si elle n'existe pas
  if (!state[name].reportsList) {
    console.log('📋 getReportsListData selector - reportsList is undefined, initializing...')
    // Retourner un tableau vide par défaut
    return []
  }
  
  const data = state[name].reportsList?.data || []
  console.log('📋 getReportsListData selector - state[name]:', state[name])
  console.log('📋 getReportsListData selector - reportsList:', state[name].reportsList)
  console.log('📋 getReportsListData selector - data:', data, 'length:', data?.length)
  return data
}
export const getReportsListLoading = (state) => state[name].reportsList?.loading || false
export const getReportsListError = (state) => state[name].reportsList?.error || null

//actions
export const {
  setSocketEnterOrExit,
  setStatusListHistory,
  setSocketStatusChange,
  setParamCadHis,
  setUpdatedEngin,
  setSelectedEnginMap,
  setSrcMouvement,
  setSelectedHistory,
  setStatusList,
  setGeoByIdSite,
  setInactiveEngin,
  setShowHistory,
  updateEnginLastSeen,
  setLastEnginUpdates,
  setStatusVisible,
  setObjectsNoActive,
  setAlertList,
  setAlertHistories,
} = engineSlice.actions

export default engineSlice.reducer
